import { api } from './index';

const UsersRequestService = {
  /*getUsers(params) {
    return api.get('users/paginated', params);
  },*/
  getUsers(params) {
    return api.get('users', params);
  },
  getUser(id) {
    return api.get('users/' + id,);
  },
  save(params) {
    return api.post('users/', params);
  },
  update(id, params) {
    return api.post('users/' + id, params);
  },
  delete(id) {
    return api.delete('users/' + id);
  },
  restore(id) {
    return api.post('users/restore/' + id);
  },
  getTrashed(params) {
    return api.get('users/trashed', params);
  },

  updateProfiles(id, params) {
    return api.post('users/' + id + '/profiles', params);
  },
  updateCompanies(id, params) {
    return api.post('users/' + id + '/companies', params);
  },

  getLanguages() {
    return api.get('languages/');
  },
  getAreasProfiles() {
    return api.get('areas-profiles/');
  },
  getUserProfiles(id) {
    return api.get('users/' + id + '/profiles');
  },
  getUserResales(id) {
    return api.get('users/' + id + '/resales');
  },
  getByCompany(companyId,params) {
    return api.get('users/get-by-company/'+companyId,params)
  },
  verifyAlreadyExists(params) {
    return api.get('users/already-exists', params)
  }
};

export default UsersRequestService;
